var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import './ReffsControlPage.scss';
import { Select, Spin, message, Card, Statistic, Row, Col, Avatar, Table, Tag, Empty, Tabs, Typography, Radio, DatePicker, Button } from 'antd';
import { DownOutlined, UserOutlined, TeamOutlined, CodeOutlined, CalendarOutlined, PhoneOutlined, MailOutlined, CrownOutlined, QrcodeOutlined, WalletOutlined, DollarOutlined, ShopOutlined, HistoryOutlined, DownloadOutlined } from '@ant-design/icons';
import { ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
import { useGetAllUsersQuery } from '@/services/usersApi';
import { useLazyGetUserReferralInfoQuery, useLazySearchReferralCodesQuery, useLazyGetUsersByReferralCodeWithPaginationQuery, useLazyGetReferralCodeInfoQuery } from '@/services/refferalApi';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/ru_RU';
import { useGetReferralInvitedPaymentsQuery, useGetReferralMonthlySpendingQuery } from '@/services/paymentApi';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
// Шрифт с поддержкой кириллицы для PDF (Roboto). Сначала пробуем локальный файл, затем CDN.
var ROBOTO_FONT_URLS = [
    '/Roboto-Regular.ttf',
    'https://cdn.jsdelivr.net/gh/googlefonts/roboto@main/src/hinted/Roboto-Regular.ttf',
    'https://raw.githubusercontent.com/googlefonts/roboto/main/src/hinted/Roboto-Regular.ttf'
];
var cachedRobotoBase64 = null;
function arrayBufferToBase64(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';
    for (var i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
function getRobotoFontBase64() {
    return __awaiter(this, void 0, Promise, function () {
        var lastError, _i, ROBOTO_FONT_URLS_1, url, res, buffer, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (cachedRobotoBase64)
                        return [2 /*return*/, cachedRobotoBase64];
                    lastError = null;
                    _i = 0, ROBOTO_FONT_URLS_1 = ROBOTO_FONT_URLS;
                    _a.label = 1;
                case 1:
                    if (!(_i < ROBOTO_FONT_URLS_1.length))
                        return [3 /*break*/, 7];
                    url = ROBOTO_FONT_URLS_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, fetch(url)];
                case 3:
                    res = _a.sent();
                    if (!res.ok)
                        return [3 /*break*/, 6];
                    return [4 /*yield*/, res.arrayBuffer()];
                case 4:
                    buffer = _a.sent();
                    if (buffer.byteLength < 1000)
                        return [3 /*break*/, 6];
                    cachedRobotoBase64 = arrayBufferToBase64(buffer);
                    return [2 /*return*/, cachedRobotoBase64];
                case 5:
                    e_1 = _a.sent();
                    lastError = e_1 instanceof Error ? e_1 : new Error(String(e_1));
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7: throw lastError !== null && lastError !== void 0 ? lastError : new Error('Не удалось загрузить шрифт');
            }
        });
    });
}
function applyCyrillicFont(doc) {
    return getRobotoFontBase64().then(function (base64) {
        doc.addFileToVFS('Roboto-Regular.ttf', base64);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');
    });
}
var Option = Select.Option;
var TabPane = Tabs.TabPane;
var Text = Typography.Text, Title = Typography.Title;
var RangePicker = DatePicker.RangePicker;
function getDateRangeFromPeriod(period, customRange) {
    var now = dayjs();
    var start;
    var end;
    if (period === 'custom' && customRange) {
        start = customRange[0], end = customRange[1];
    }
    else if (period === 'day') {
        start = now.startOf('day');
        end = now.endOf('day');
    }
    else if (period === 'week') {
        start = now.subtract(1, 'week').startOf('day');
        end = now.endOf('day');
    }
    else if (period === 'month') {
        start = now.subtract(1, 'month').startOf('day');
        end = now.endOf('day');
    }
    else if (period === 'year') {
        start = now.subtract(1, 'year').startOf('day');
        end = now.endOf('day');
    }
    else {
        return null;
    }
    return {
        startDate: start.toISOString(),
        endDate: end.toISOString()
    };
}
function getChatTypeLabel(tabletId) {
    if (tabletId === '0')
        return 'External чат';
    if (tabletId === 'coin_payment' || tabletId === 'coin_payment_fallback')
        return 'Оплата монетами';
    if (tabletId === 'transfer')
        return 'Перевод';
    if (tabletId === 'admin_charge')
        return 'Внутреннее';
    if (tabletId === 'purchase')
        return 'Покупка';
    return 'Обычный чат';
}
var ReffsControlPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    // State для пользователей
    var _r = useState(null), selectedUser = _r[0], setSelectedUser = _r[1];
    var _s = useState(''), userSearchTerm = _s[0], setUserSearchTerm = _s[1];
    var _t = useState(''), debouncedUserSearch = _t[0], setDebouncedUserSearch = _t[1];
    // State для реферальных кодов
    var _u = useState(null), selectedReferralCode = _u[0], setSelectedReferralCode = _u[1];
    var _v = useState(''), codeSearchTerm = _v[0], setCodeSearchTerm = _v[1];
    var _w = useState(''), debouncedCodeSearch = _w[0], setDebouncedCodeSearch = _w[1];
    // Фильтр по дате для оплат
    var _x = useState('month'), datePeriod = _x[0], setDatePeriod = _x[1];
    var _y = useState(null), customDateRange = _y[0], setCustomDateRange = _y[1];
    // Хуки для реферальной информации пользователя
    var _z = useLazyGetUserReferralInfoQuery(), getUserReferralInfo = _z[0], _0 = _z[1], referralInfo = _0.data, isReferralLoading = _0.isLoading, isReferralFetching = _0.isFetching;
    // Хуки для реферальных кодов
    var _1 = useLazySearchReferralCodesQuery(), searchReferralCodes = _1[0], _2 = _1[1], referralCodesData = _2.data, isCodesLoading = _2.isLoading, isCodesFetching = _2.isFetching;
    var _3 = useLazyGetUsersByReferralCodeWithPaginationQuery(), getUsersByReferralCode = _3[0], _4 = _3[1], referralCodeUsersData = _4.data, isCodeUsersLoading = _4.isLoading, isCodeUsersFetching = _4.isFetching;
    var _5 = useLazyGetReferralCodeInfoQuery(), getReferralCodeInfo = _5[0], referralCodeInfo = _5[1].data;
    // referrerUserId: при поиске по пользователю — сам пользователь; при поиске по коду — владелец кода
    var referrerUserId = (_b = selectedUser !== null && selectedUser !== void 0 ? selectedUser : (_a = referralCodeInfo === null || referralCodeInfo === void 0 ? void 0 : referralCodeInfo.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0;
    // Вычисляем startDate/endDate для API
    var dateFilter = React.useMemo(function () {
        var range = getDateRangeFromPeriod(datePeriod, customDateRange);
        if (!range)
            return { startDate: undefined, endDate: undefined };
        return range;
    }, [datePeriod, customDateRange]);
    // Хуки для статистики оплат приглашённых
    var _6 = useGetReferralInvitedPaymentsQuery(referrerUserId ? __assign({ referrerUserId: referrerUserId }, dateFilter) : { referrerUserId: 0 }, { skip: !referrerUserId }), invitedPaymentsData = _6.data, isInvitedPaymentsLoading = _6.isLoading;
    var _7 = useGetReferralMonthlySpendingQuery(referrerUserId ? __assign({ referrerUserId: referrerUserId }, dateFilter) : { referrerUserId: 0 }, { skip: !referrerUserId }), referralMonthlySpending = _7.data, isReferralMonthlyLoading = _7.isLoading;
    // Дебаунс для поиска пользователей
    useEffect(function () {
        var timer = setTimeout(function () {
            setDebouncedUserSearch(userSearchTerm);
        }, 500);
        return function () { return clearTimeout(timer); };
    }, [userSearchTerm]);
    // Дебаунс для поиска реферальных кодов
    useEffect(function () {
        var timer = setTimeout(function () {
            setDebouncedCodeSearch(codeSearchTerm);
        }, 500);
        return function () { return clearTimeout(timer); };
    }, [codeSearchTerm]);
    // Получение ВСЕХ пользователей
    var _8 = useGetAllUsersQuery({
        search: debouncedUserSearch
    }, {
        skip: false,
        refetchOnMountOrArgChange: true
    }), usersData = _8.data, isUsersLoading = _8.isLoading, isFetching = _8.isFetching;
    // getAllUsers возвращает массив пользователей (transformResponse в usersApi)
    var userList = React.useMemo(function () {
        if (!usersData)
            return [];
        return Array.isArray(usersData) ? usersData : [];
    }, [usersData]);
    // Поиск реферальных кодов
    useEffect(function () {
        searchReferralCodes({ search: debouncedCodeSearch });
    }, [debouncedCodeSearch, searchReferralCodes]);
    // Загрузка данных при выборе пользователя
    useEffect(function () {
        if (selectedUser) {
            getUserReferralInfo({ userId: selectedUser });
        }
    }, [selectedUser, getUserReferralInfo]);
    // Загрузка данных при выборе реферального кода
    useEffect(function () {
        if (selectedReferralCode) {
            getUsersByReferralCode({
                referralCode: selectedReferralCode,
                page: 1,
                limit: 10
            });
            getReferralCodeInfo({ referralCode: selectedReferralCode });
        }
    }, [selectedReferralCode, getUsersByReferralCode, getReferralCodeInfo]);
    var handleUserChange = function (value) {
        setSelectedUser(value);
        setSelectedReferralCode(null);
        if (value) {
            var user = userList.find(function (u) { return u.id === value; });
            if (user) {
                message.success("\u0412\u044B\u0431\u0440\u0430\u043D \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C: ".concat(user.fullName || user.login || 'Без имени'));
            }
        }
    };
    var handleUserSearch = function (value) {
        setUserSearchTerm(value);
    };
    var handleReferralCodeChange = function (value) {
        setSelectedReferralCode(value);
        setSelectedUser(null);
        if (value) {
            var codeInfo = referralCodesData === null || referralCodesData === void 0 ? void 0 : referralCodesData.find(function (c) { return c.referralCode === value; });
            if (codeInfo) {
                message.success("\u0412\u044B\u0431\u0440\u0430\u043D \u0440\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434: ".concat(value, " (").concat(codeInfo.user.fullName || codeInfo.user.login, ")"));
            }
        }
    };
    var handleReferralCodeSearch = function (value) {
        setCodeSearchTerm(value);
    };
    // Подпись периода для PDF
    var getPeriodLabel = function () {
        if (datePeriod === 'custom' && customDateRange && customDateRange[0] && customDateRange[1]) {
            return "".concat(customDateRange[0].format('DD.MM.YYYY'), " \u2014 ").concat(customDateRange[1].format('DD.MM.YYYY'));
        }
        var labels = {
            day: 'За день',
            week: 'За неделю',
            month: 'За месяц',
            year: 'За год',
            custom: 'Выбранный период'
        };
        return labels[datePeriod];
    };
    // Скачать PDF с таблицами оплат за период
    var _9 = useState(false), pdfLoading = _9[0], setPdfLoading = _9[1];
    var handleDownloadPdf = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var payments, cashPayments, coinPayments, coinTransactions, doc, head, row_1, rowCoinTx, y, allCoinsForPdf, fileName, e_2;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        payments = (_a = invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.payments) !== null && _a !== void 0 ? _a : [];
                        cashPayments = payments.filter(function (p) { return p.paymentMethod === 'cash'; });
                        coinPayments = payments.filter(function (p) { return p.paymentMethod === 'coins'; });
                        coinTransactions = (_b = invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.coinTransactions) !== null && _b !== void 0 ? _b : [];
                        setPdfLoading(true);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
                        return [4 /*yield*/, applyCyrillicFont(doc)];
                    case 2:
                        _e.sent();
                        head = [['Пользователь', 'Дата', 'Сумма', 'Тип чата', 'Ресторан']];
                        doc.setFontSize(16);
                        doc.text('Платежи приглашенных', 14, 15);
                        doc.setFontSize(10);
                        doc.text(getPeriodLabel(), 14, 22);
                        row_1 = function (p) {
                            var _a, _b;
                            var user = invitedUsersMap[Number(p.userId)];
                            var userName = user ? (user.fullName || user.login || "ID ".concat(p.userId)) : "ID ".concat(p.userId);
                            return [
                                userName,
                                dayjs(p.createdAt).format('DD.MM.YYYY HH:mm'),
                                p.paymentMethod === 'cash' ? formatAmount(p.amount) : "".concat(p.amount, " \u043C\u043E\u043D\u0435\u0442"),
                                getChatTypeLabel(p.tabletId),
                                (_b = (_a = p.restaurant) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '—'
                            ];
                        };
                        rowCoinTx = function (t) {
                            var user = invitedUsersMap[t.senderId];
                            var userName = user ? (user.fullName || user.login || "ID ".concat(t.senderId)) : "ID ".concat(t.senderId);
                            return [
                                userName,
                                dayjs(t.createdAt).format('DD.MM.YYYY HH:mm'),
                                "".concat(t.amount, " \u043C\u043E\u043D\u0435\u0442"),
                                getChatTypeLabel(t.type),
                                '—'
                            ];
                        };
                        y = 28;
                        if (cashPayments.length > 0) {
                            doc.setFontSize(12);
                            doc.text('Реальные оплаты (₽)', 14, y);
                            y += 6;
                            doc.autoTable({
                                startY: y,
                                head: head,
                                body: cashPayments.map(function (p) { return row_1(p); }),
                                margin: { left: 14 },
                                styles: { fontSize: 8, font: 'Roboto' },
                                headStyles: { fillColor: [82, 196, 26], font: 'Roboto' }
                            });
                            y = ((_d = (_c = doc.lastAutoTable) === null || _c === void 0 ? void 0 : _c.finalY) !== null && _d !== void 0 ? _d : y) + 10;
                        }
                        allCoinsForPdf = __spreadArray(__spreadArray([], coinPayments.map(function (p) { return row_1(p); }), true), coinTransactions.map(rowCoinTx), true);
                        if (allCoinsForPdf.length > 0) {
                            if (y > 250) {
                                doc.addPage();
                                y = 15;
                            }
                            doc.setFontSize(12);
                            doc.text('Оплаты eGo Coin', 14, y);
                            y += 6;
                            doc.autoTable({
                                startY: y,
                                head: head,
                                body: allCoinsForPdf,
                                margin: { left: 14 },
                                styles: { fontSize: 8, font: 'Roboto' },
                                headStyles: { fillColor: [250, 173, 20], font: 'Roboto' }
                            });
                        }
                        if (cashPayments.length === 0 && allCoinsForPdf.length === 0) {
                            doc.setFontSize(10);
                            doc.text('Нет данных за выбранный период', 14, y);
                        }
                        fileName = "platezhi-priglashennyh_".concat(dayjs().format('YYYY-MM-DD_HH-mm'), ".pdf");
                        doc.save(fileName);
                        message.success('PDF сохранён');
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _e.sent();
                        console.error(e_2);
                        message.error('Не удалось создать PDF. Проверьте подключение к интернету для загрузки шрифта.');
                        return [3 /*break*/, 5];
                    case 4:
                        setPdfLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Получаем информацию о выбранном пользователе
    var selectedUserInfo = userList.find(function (u) { return u.id === selectedUser; });
    // Форматирование даты
    var formatDate = function (date) {
        return dayjs(date).format('DD.MM.YYYY HH:mm');
    };
    // Форматирование суммы
    var formatAmount = function (amount) {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };
    // Колонки для таблицы приглашенных пользователей (для пользователя)
    var userColumns = [
        {
            title: 'Пользователь',
            dataIndex: 'fullName',
            key: 'fullName',
            render: function (text, record) {
                return (_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(Avatar, { src: record.photoURL, icon: !record.photoURL && _jsx(UserOutlined, {}), style: {
                                backgroundColor: record.photoURL ? 'transparent' : (record.status ? '#52c41a' : '#faad14'),
                                marginRight: 12
                            } }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontWeight: 500 } }, { children: record.fullName || record.login || 'Без имени' })), _jsxs("div", __assign({ style: { fontSize: 12, color: '#999' } }, { children: ["ID: ", record.id] }))] })] })));
            },
        },
        {
            title: 'Телефон',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: function (text) { return text || '—'; },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: function (text) { return text || '—'; },
        },
        {
            title: 'Роль',
            dataIndex: 'role',
            key: 'role',
            render: function (text) {
                var roleColors = {
                    'admin': 'red',
                    'moderator': 'orange',
                    'user': 'blue',
                    'partner': 'purple',
                    'системный администратор': 'red',
                    'системный менеджер': 'orange',
                    'сотрудник': 'blue'
                };
                return (_jsx(Tag, __assign({ color: roleColors[text] || 'default' }, { children: text || 'user' })));
            },
        },
        {
            title: 'Дата регистрации',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: function (text) { return (_jsxs("div", { children: [_jsx(CalendarOutlined, { style: { marginRight: 8, color: '#999' } }), dayjs(text).format('DD.MM.YYYY HH:mm')] })); },
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            key: 'status',
            render: function (status) {
                if (status === null)
                    return _jsx(Tag, __assign({ color: "default" }, { children: "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D" }));
                return status ?
                    _jsx(Tag, __assign({ color: "success" }, { children: "\u0410\u043A\u0442\u0438\u0432\u0435\u043D" })) :
                    _jsx(Tag, __assign({ color: "error" }, { children: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D" }));
            },
        },
    ];
    // Колонки для таблицы приглашенных пользователей (для реферального кода)
    var codeColumns = [
        {
            title: 'Пользователь',
            dataIndex: 'fullName',
            key: 'fullName',
            render: function (text, record) {
                return (_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(Avatar, { src: record.photoURL, icon: !record.photoURL && _jsx(UserOutlined, {}), style: {
                                backgroundColor: record.photoURL ? 'transparent' : (record.status ? '#52c41a' : '#faad14'),
                                marginRight: 12
                            } }), _jsxs("div", { children: [_jsx("div", __assign({ style: { fontWeight: 500 } }, { children: record.fullName || record.login || 'Без имени' })), _jsxs("div", __assign({ style: { fontSize: 12, color: '#999' } }, { children: ["ID: ", record.id] }))] })] })));
            },
        },
        {
            title: 'Телефон',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: function (text) { return text || '—'; },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: function (text) { return text || '—'; },
        },
        {
            title: 'Дата регистрации',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: function (text) { return (_jsxs("div", { children: [_jsx(CalendarOutlined, { style: { marginRight: 8, color: '#999' } }), dayjs(text).format('DD.MM.YYYY HH:mm')] })); },
        },
    ];
    // Приглашённые пользователи (для отображения имён в таблице платежей)
    var invitedUsersList = selectedUser
        ? ((_c = referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.invitedUsers) !== null && _c !== void 0 ? _c : [])
        : ((_d = referralCodeUsersData === null || referralCodeUsersData === void 0 ? void 0 : referralCodeUsersData.users) !== null && _d !== void 0 ? _d : []);
    var invitedUsersMap = React.useMemo(function () {
        var m = {};
        invitedUsersList.forEach(function (u) { m[u.id] = u; });
        return m;
    }, [invitedUsersList]);
    // Все операции с коинами: платежи (Payments) + транзакции (CoinTransaction), отсортированы по дате
    var allCoinsRows = React.useMemo(function () {
        var _a, _b;
        var payments = (_a = invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.payments) !== null && _a !== void 0 ? _a : [];
        var coinPayments = payments.filter(function (p) { return p.paymentMethod === 'coins'; });
        var txList = (_b = invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.coinTransactions) !== null && _b !== void 0 ? _b : [];
        var txRows = txList.map(function (t) {
            return ({
                id: "ct-".concat(t.id),
                userId: String(t.senderId),
                amount: t.amount,
                createdAt: t.createdAt,
                paymentMethod: 'coins',
                tabletId: t.type || 'transfer',
                restaurant: undefined
            });
        });
        var combined = __spreadArray(__spreadArray([], coinPayments, true), txRows, true);
        combined.sort(function (a, b) { return dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf(); });
        return combined;
    }, [invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.payments, invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.coinTransactions]);
    // Колонки для таблицы платежей приглашённых (с колонкой «Пользователь»)
    var paymentColumns = [
        {
            title: 'Пользователь',
            dataIndex: 'userId',
            key: 'userId',
            width: 200,
            render: function (userId) {
                var user = invitedUsersMap[Number(userId)];
                return (_jsxs("span", { children: [_jsx(UserOutlined, { style: { marginRight: 8, color: '#999' } }), user ? (user.fullName || user.login || "ID ".concat(userId)) : "ID ".concat(userId)] }));
            },
        },
        {
            title: 'Дата',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
            render: function (text) { return (_jsxs("div", { children: [_jsx(CalendarOutlined, { style: { marginRight: 8, color: '#999' } }), dayjs(text).format('DD.MM.YYYY HH:mm')] })); },
            sorter: function (a, b) { return dayjs(a.createdAt).unix() - dayjs(b.createdAt).unix(); },
            defaultSortOrder: 'descend',
        },
        {
            title: 'Сумма',
            dataIndex: 'amount',
            key: 'amount',
            width: 150,
            render: function (amount, record) { return (_jsx(Text, __assign({ strong: true, style: { color: record.paymentMethod === 'cash' ? '#52c41a' : '#faad14' } }, { children: record.paymentMethod === 'cash' ? formatAmount(amount) : "".concat(amount, " \u043C\u043E\u043D\u0435\u0442") }))); },
            sorter: function (a, b) { return a.amount - b.amount; },
        },
        {
            title: 'Тип чата',
            dataIndex: 'tabletId',
            key: 'chatType',
            width: 150,
            render: function (tabletId) {
                if (tabletId === '0')
                    return _jsx(Tag, __assign({ color: "purple", icon: _jsx(TeamOutlined, {}) }, { children: "External \u0447\u0430\u0442" }));
                if (tabletId === 'coin_payment' || tabletId === 'coin_payment_fallback')
                    return _jsx(Tag, __assign({ color: "blue", icon: _jsx(WalletOutlined, {}) }, { children: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043C\u043E\u043D\u0435\u0442\u0430\u043C\u0438" }));
                return _jsx(Tag, __assign({ color: "cyan", icon: _jsx(ShopOutlined, {}) }, { children: "\u041E\u0431\u044B\u0447\u043D\u044B\u0439 \u0447\u0430\u0442" }));
            },
        },
        {
            title: 'Ресторан',
            dataIndex: ['restaurant', 'name'],
            key: 'restaurant',
            render: function (text, record) {
                var _a;
                return (_jsxs("span", { children: [_jsx(ShopOutlined, { style: { marginRight: 8, color: '#999' } }), ((_a = record.restaurant) === null || _a === void 0 ? void 0 : _a.name) || '—'] }));
            },
        },
    ];
    return (_jsxs("div", __assign({ className: 'ReffsControlPage' }, { children: [_jsx("div", __assign({ className: 'titleBlock' }, { children: _jsx("span", { children: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0420\u0435\u0444\u0435\u0440\u0430\u043B\u043E\u0432" }) })), _jsxs("div", __assign({ style: { padding: '24px 40px' } }, { children: [_jsx(Card, __assign({ style: { marginBottom: 24, borderRadius: 12 } }, { children: _jsxs(Tabs, __assign({ defaultActiveKey: "user", type: "card" }, { children: [_jsx(TabPane, __assign({ tab: _jsxs("span", { children: [_jsx(UserOutlined, {}), " \u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C"] }) }, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: 16 } }, { children: [_jsx("span", __assign({ style: { fontSize: 14, color: '#666' } }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F:" })), _jsx(Select, __assign({ showSearch: true, allowClear: true, placeholder: _jsx("span", __assign({ style: { fontSize: 14 } }, { children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F, \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0438\u043B\u0438 email..." })), optionFilterProp: "children", onChange: handleUserChange, onSearch: handleUserSearch, value: selectedUser, loading: isUsersLoading || isFetching, style: { fontSize: 13, minWidth: 400 }, dropdownStyle: { fontSize: 12 }, suffixIcon: _jsx(DownOutlined, { style: { fontSize: 11 } }), filterOption: false, notFoundContent: isUsersLoading || isFetching ? _jsx(Spin, { size: "small" }) : 'Пользователи не найдены', defaultActiveFirstOption: false }, { children: userList.map(function (user) {
                                                    return (_jsx(Option, __assign({ value: user.id, style: { fontSize: 12 } }, { children: _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, { children: [_jsx("span", __assign({ style: { fontWeight: 500, fontSize: "14px" } }, { children: user.fullName || user.login ?
                                                                        "".concat(user.fullName || '', " ").concat(user.login || '').trim() :
                                                                        'Без имени' })), _jsx(Tag, __assign({ color: "blue", style: { marginLeft: 8 } }, { children: user.role || 'user' }))] })) }), user.id));
                                                }) }))] })) }), "user"), _jsx(TabPane, __assign({ tab: _jsxs("span", { children: [_jsx(QrcodeOutlined, {}), " \u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0440\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u043C \u043A\u043E\u0434\u0430\u043C"] }) }, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: 16 } }, { children: [_jsx("span", __assign({ style: { fontSize: 14, color: '#666' } }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434:" })), _jsx(Select, __assign({ showSearch: true, allowClear: true, placeholder: _jsx("span", __assign({ style: { fontSize: 14 } }, { children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434 \u0438\u043B\u0438 \u0438\u043C\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430..." })), optionFilterProp: "children", onChange: handleReferralCodeChange, onSearch: handleReferralCodeSearch, value: selectedReferralCode, loading: isCodesLoading || isCodesFetching, style: { fontSize: 13, minWidth: 400 }, dropdownStyle: { fontSize: 12 }, suffixIcon: _jsx(DownOutlined, { style: { fontSize: 11 } }), filterOption: false, notFoundContent: isCodesLoading || isCodesFetching ? _jsx(Spin, { size: "small" }) : 'Реферальные коды не найдены', defaultActiveFirstOption: false }, { children: referralCodesData === null || referralCodesData === void 0 ? void 0 : referralCodesData.map(function (code) { return (_jsx(Option, __assign({ value: code.referralCode, style: { fontSize: 12 } }, { children: _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, { children: [_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: 12 } }, { children: [_jsx(Tag, __assign({ color: "blue", style: { fontSize: 12, fontWeight: 600 } }, { children: code.referralCode })), _jsx("span", __assign({ style: { fontWeight: 500, fontSize: "14px" } }, { children: code.user.fullName || code.user.login || 'Без имени' }))] })), _jsxs("span", __assign({ style: { color: '#999', fontSize: '12px' } }, { children: ["\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043E: ", code.invitedUsersCount] }))] })) }), code.referralCode)); }) })), selectedReferralCode && referralCodeInfo && (_jsxs(Tag, __assign({ color: "green", style: { marginLeft: 8 } }, { children: ["\u0421\u043E\u0437\u0434\u0430\u043D: ", dayjs(referralCodeInfo.createdAt).format('DD.MM.YYYY')] })))] })) }), "code")] })) })), !selectedUser && !selectedReferralCode ? (_jsx(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u0440\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438", style: {
                            background: '#fff',
                            padding: '48px 0',
                            borderRadius: 12,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                        } })) : (_jsxs(_Fragment, { children: [selectedUser && selectedUserInfo && (_jsx(Card, __assign({ style: {
                                    marginBottom: 24,
                                    borderRadius: 12,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                } }, { children: _jsxs(Row, __assign({ gutter: [24, 24], align: "middle" }, { children: [_jsx(Col, { children: _jsx(Avatar, { size: 64, src: selectedUserInfo.photoURL, icon: !selectedUserInfo.photoURL && _jsx(UserOutlined, {}), style: { backgroundColor: '#1890ff' } }) }), _jsx(Col, __assign({ flex: "1" }, { children: _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' } }, { children: [_jsxs("div", { children: [_jsx("h2", __assign({ style: { margin: 0, marginBottom: 8, fontSize: 20 } }, { children: selectedUserInfo.fullName || selectedUserInfo.login || 'Пользователь' })), _jsxs("div", __assign({ style: { display: 'flex', gap: 24, color: '#666', flexWrap: 'wrap' } }, { children: [selectedUserInfo.phoneNumber && (_jsxs("span", { children: [_jsx(PhoneOutlined, { style: { marginRight: 8 } }), selectedUserInfo.phoneNumber] })), selectedUserInfo.email && (_jsxs("span", { children: [_jsx(MailOutlined, { style: { marginRight: 8 } }), selectedUserInfo.email] })), _jsxs("span", { children: [_jsx(CodeOutlined, { style: { marginRight: 8 } }), "ID: ", selectedUser] }), _jsx("span", { children: _jsx(Tag, __assign({ color: selectedUserInfo.role === 'системный администратор' ? 'red' : 'blue' }, { children: selectedUserInfo.role || 'user' })) })] }))] }), (referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.referralCode) && (_jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("div", __assign({ style: { color: '#999', fontSize: 13, marginBottom: 4 } }, { children: "\u0420\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434" })), _jsx(Tag, __assign({ color: "blue", style: {
                                                                    fontSize: 16,
                                                                    padding: '4px 12px',
                                                                    fontWeight: 600
                                                                } }, { children: referralInfo.referralCode }))] })))] })) }))] })) }))), selectedReferralCode && referralCodeInfo && (_jsx(Card, __assign({ style: {
                                    marginBottom: 24,
                                    borderRadius: 12,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                } }, { children: _jsxs(Row, __assign({ gutter: [24, 24], align: "middle" }, { children: [_jsx(Col, { children: _jsx(Avatar, { size: 64, src: referralCodeInfo.user.photoURL, icon: !referralCodeInfo.user.photoURL && _jsx(UserOutlined, {}), style: { backgroundColor: '#722ed1' } }) }), _jsx(Col, __assign({ flex: "1" }, { children: _jsx("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' } }, { children: _jsxs("div", { children: [_jsx("h2", __assign({ style: { margin: 0, marginBottom: 8, fontSize: 20 } }, { children: referralCodeInfo.user.fullName || referralCodeInfo.user.login || 'Владелец кода' })), _jsxs("div", __assign({ style: { display: 'flex', gap: 24, color: '#666', flexWrap: 'wrap' } }, { children: [_jsxs("span", { children: [_jsx(QrcodeOutlined, { style: { marginRight: 8 } }), "\u041A\u043E\u0434: ", _jsx(Tag, __assign({ color: "blue" }, { children: referralCodeInfo.referralCode }))] }), _jsxs("span", { children: [_jsx(CalendarOutlined, { style: { marginRight: 8 } }), "\u0421\u043E\u0437\u0434\u0430\u043D: ", dayjs(referralCodeInfo.createdAt).format('DD.MM.YYYY')] }), _jsxs("span", { children: [_jsx(TeamOutlined, { style: { marginRight: 8 } }), "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043E: ", referralCodeInfo.invitedUsersCount] })] }))] }) })) }))] })) }))), selectedUser && (_jsx(_Fragment, { children: _jsxs(Row, __assign({ gutter: [24, 24], style: { marginBottom: 24 } }, { children: [_jsx(Col, __assign({ xs: 24, sm: 12, md: 8 }, { children: _jsx(Card, __assign({ style: {
                                                    borderRadius: 12,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                                } }, { children: _jsx(Statistic, { title: "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439", value: (_e = referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.invitedCount) !== null && _e !== void 0 ? _e : 0, prefix: _jsx(TeamOutlined, {}), loading: isReferralLoading || isReferralFetching, valueStyle: { color: '#1890ff', fontSize: 28 } }) })) })), _jsx(Col, __assign({ xs: 24, sm: 12, md: 8 }, { children: _jsxs(Card, __assign({ style: {
                                                    borderRadius: 12,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                                } }, { children: [_jsx(Statistic, { title: "\u041A\u0442\u043E \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u043B", value: ((_f = referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.referrer) === null || _f === void 0 ? void 0 : _f.fullName) || '—', prefix: _jsx(CrownOutlined, {}), loading: isReferralLoading || isReferralFetching, valueStyle: { fontSize: 18 } }), (referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.referrer) && (_jsxs("div", __assign({ style: { fontSize: 12, color: '#999', marginTop: 8 } }, { children: ["ID: ", referralInfo.referrer.id] })))] })) })), _jsx(Col, __assign({ xs: 24, sm: 24, md: 8 }, { children: _jsx(Card, __assign({ style: {
                                                    borderRadius: 12,
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                                } }, { children: _jsx(Statistic, { title: "\u0420\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0432\u0448\u0435\u0433\u043E", value: ((_g = referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.referrer) === null || _g === void 0 ? void 0 : _g.referralCode) || '—', prefix: _jsx(CodeOutlined, {}), loading: isReferralLoading || isReferralFetching, valueStyle: { fontSize: 18 } }) })) }))] })) })), referrerUserId > 0 && (_jsx(Card, __assign({ style: { marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' } }, { children: _jsxs("div", __assign({ style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16 } }, { children: [_jsx("span", __assign({ style: { fontWeight: 500, color: '#666' } }, { children: "\u041F\u0435\u0440\u0438\u043E\u0434:" })), _jsxs(Radio.Group, __assign({ value: datePeriod, onChange: function (e) {
                                                setDatePeriod(e.target.value);
                                                if (e.target.value !== 'custom')
                                                    setCustomDateRange(null);
                                            }, optionType: "button" }, { children: [_jsx(Radio.Button, __assign({ value: "day" }, { children: "\u0414\u0435\u043D\u044C" })), _jsx(Radio.Button, __assign({ value: "week" }, { children: "\u041D\u0435\u0434\u0435\u043B\u044F" })), _jsx(Radio.Button, __assign({ value: "month" }, { children: "\u041C\u0435\u0441\u044F\u0446" })), _jsx(Radio.Button, __assign({ value: "year" }, { children: "\u0413\u043E\u0434" })), _jsx(Radio.Button, __assign({ value: "custom" }, { children: "\u0412\u0440\u0443\u0447\u043D\u0443\u044E" }))] })), datePeriod === 'custom' && (_jsx(RangePicker, { value: customDateRange, onChange: function (dates) { return setCustomDateRange(dates); }, locale: locale, format: "DD.MM.YYYY", placeholder: ['От', 'До'] })), _jsx(Button, __assign({ type: "primary", icon: _jsx(DownloadOutlined, {}), onClick: handleDownloadPdf, loading: pdfLoading, style: { marginLeft: 'auto' } }, { children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C PDF" }))] })) }))), referrerUserId > 0 && (((_h = referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.invitedCount) !== null && _h !== void 0 ? _h : 0) > 0 || ((_j = referralCodeUsersData === null || referralCodeUsersData === void 0 ? void 0 : referralCodeUsersData.total) !== null && _j !== void 0 ? _j : 0) > 0) && (_jsxs(_Fragment, { children: [_jsxs(Title, __assign({ level: 4, style: { marginBottom: 16, display: 'flex', alignItems: 'center' } }, { children: [_jsx(TeamOutlined, { style: { marginRight: 12, color: '#1890ff' } }), "\u0422\u0440\u0430\u0442\u044B \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0451\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u043C\u0435\u0441\u044F\u0446\u0430\u043C"] })), _jsxs(Row, __assign({ gutter: [24, 24], style: { marginBottom: 24 } }, { children: [_jsx(Col, __assign({ xs: 24, lg: 12 }, { children: _jsx(Card, __assign({ title: _jsxs("span", { children: [_jsx(DollarOutlined, { style: { marginRight: 8, color: '#52c41a' } }), "\u0420\u0435\u0430\u043B\u044C\u043D\u044B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B (\u20BD) \u043F\u043E \u043C\u0435\u0441\u044F\u0446\u0430\u043C"] }), style: { borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }, loading: isReferralMonthlyLoading }, { children: ((_l = (_k = referralMonthlySpending === null || referralMonthlySpending === void 0 ? void 0 : referralMonthlySpending.rublesByMonth) === null || _k === void 0 ? void 0 : _k.length) !== null && _l !== void 0 ? _l : 0) > 0 ? (_jsx(ResponsiveContainer, __assign({ width: "100%", height: 300 }, { children: _jsxs(BarChart, __assign({ data: (_m = referralMonthlySpending === null || referralMonthlySpending === void 0 ? void 0 : referralMonthlySpending.rublesByMonth) !== null && _m !== void 0 ? _m : [], margin: { top: 20, right: 30, left: 20, bottom: 60 } }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3" }), _jsx(XAxis, { dataKey: "month", angle: -45, textAnchor: "end", height: 80 }), _jsx(YAxis, { tickFormatter: function (v) { return "".concat(v, " \u20BD"); } }), _jsx(Tooltip, { formatter: function (value) { return [formatAmount(value), 'Сумма']; } }), _jsx(Bar, { dataKey: "total", fill: "#52c41a", name: "\u0420\u0443\u0431\u043B\u0438", radius: [4, 4, 0, 0] })] })) }))) : (_jsx(Empty, { description: "\u041D\u0435\u0442 \u0440\u0443\u0431\u043B\u0451\u0432\u044B\u0445 \u0442\u0440\u0430\u0442 \u0443 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0451\u043D\u043D\u044B\u0445", style: { padding: 40 } })) })) })), _jsx(Col, __assign({ xs: 24, lg: 12 }, { children: _jsx(Card, __assign({ title: _jsxs("span", { children: [_jsx(WalletOutlined, { style: { marginRight: 8, color: '#faad14' } }), "\u041E\u043F\u043B\u0430\u0442\u044B eGo Coin \u043F\u043E \u043C\u0435\u0441\u044F\u0446\u0430\u043C"] }), style: { borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }, loading: isReferralMonthlyLoading }, { children: ((_p = (_o = referralMonthlySpending === null || referralMonthlySpending === void 0 ? void 0 : referralMonthlySpending.coinsByMonth) === null || _o === void 0 ? void 0 : _o.length) !== null && _p !== void 0 ? _p : 0) > 0 ? (_jsx(ResponsiveContainer, __assign({ width: "100%", height: 300 }, { children: _jsxs(BarChart, __assign({ data: (_q = referralMonthlySpending === null || referralMonthlySpending === void 0 ? void 0 : referralMonthlySpending.coinsByMonth) !== null && _q !== void 0 ? _q : [], margin: { top: 20, right: 30, left: 20, bottom: 60 } }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3" }), _jsx(XAxis, { dataKey: "month", angle: -45, textAnchor: "end", height: 80 }), _jsx(YAxis, { tickFormatter: function (v) { return "".concat(v, " \u043C\u043E\u043D\u0435\u0442"); } }), _jsx(Tooltip, { formatter: function (value) { return ["".concat(value, " \u043C\u043E\u043D\u0435\u0442"), 'Сумма']; } }), _jsx(Bar, { dataKey: "total", fill: "#faad14", name: "\u041C\u043E\u043D\u0435\u0442\u044B", radius: [4, 4, 0, 0] })] })) }))) : (_jsx(Empty, { description: "\u041D\u0435\u0442 \u0442\u0440\u0430\u0442 \u043C\u043E\u043D\u0435\u0442\u0430\u043C\u0438 \u0443 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0451\u043D\u043D\u044B\u0445", style: { padding: 40 } })) })) }))] }))] })), referrerUserId > 0 && (_jsx(Card, __assign({ title: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(HistoryOutlined, { style: { marginRight: 12, color: '#1890ff' } }), _jsx("span", { children: "\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043D\u044B\u0445" })] })), style: { marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }, loading: isInvitedPaymentsLoading }, { children: _jsxs(Tabs, __assign({ defaultActiveKey: "cash", type: "card" }, { children: [_jsx(TabPane, __assign({ tab: _jsxs("span", { children: [_jsx(DollarOutlined, {}), " \u0420\u0435\u0430\u043B\u044C\u043D\u044B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B (\u20BD)"] }) }, { children: _jsx(Table, { columns: paymentColumns, dataSource: ((invitedPaymentsData === null || invitedPaymentsData === void 0 ? void 0 : invitedPaymentsData.payments) || []).filter(function (p) { return p.paymentMethod === 'cash'; }), rowKey: "id", pagination: { pageSize: 10, showTotal: function (t) { return "\u0412\u0441\u0435\u0433\u043E ".concat(t); } }, locale: {
                                                    emptyText: (_jsx(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u041D\u0435\u0442 \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u043F\u043B\u0430\u0442 \u0443 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0451\u043D\u043D\u044B\u0445" }))
                                                }, scroll: { x: 800 } }) }), "cash"), _jsx(TabPane, __assign({ tab: _jsxs("span", { children: [_jsx(WalletOutlined, {}), " \u041E\u043F\u043B\u0430\u0442\u044B eGo Coin"] }) }, { children: _jsx(Table, { columns: paymentColumns, dataSource: allCoinsRows, rowKey: "id", pagination: { pageSize: 10, showTotal: function (t) { return "\u0412\u0441\u0435\u0433\u043E ".concat(t); } }, locale: {
                                                    emptyText: (_jsx(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u041D\u0435\u0442 \u043E\u043F\u043B\u0430\u0442 \u043C\u043E\u043D\u0435\u0442\u0430\u043C\u0438 \u0443 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0451\u043D\u043D\u044B\u0445" }))
                                                }, scroll: { x: 800 } }) }), "coins")] })) }))), _jsx(Card, __assign({ title: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(TeamOutlined, { style: { marginRight: 12 } }), _jsx("span", { children: selectedUser ? 'Приглашенные пользователи' : 'Пользователи по реферальному коду' }), selectedUser && referralInfo && referralInfo.invitedCount > 0 && (_jsxs(Tag, __assign({ color: "blue", style: { marginLeft: 12 } }, { children: ["\u0412\u0441\u0435\u0433\u043E: ", referralInfo.invitedCount] }))), selectedReferralCode && referralCodeUsersData && referralCodeUsersData.total > 0 && (_jsxs(Tag, __assign({ color: "purple", style: { marginLeft: 12 } }, { children: ["\u0412\u0441\u0435\u0433\u043E: ", referralCodeUsersData.total] })))] })), style: {
                                    borderRadius: 12,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                                } }, { children: selectedUser && (isReferralLoading || isReferralFetching) ? (_jsx("div", __assign({ style: { textAlign: 'center', padding: '48px 0' } }, { children: _jsx(Spin, { size: "large" }) }))) : selectedReferralCode && (isCodeUsersLoading || isCodeUsersFetching) ? (_jsx("div", __assign({ style: { textAlign: 'center', padding: '48px 0' } }, { children: _jsx(Spin, { size: "large" }) }))) : (_jsx(Table, { columns: selectedUser ? userColumns : codeColumns, dataSource: selectedUser
                                        ? ((referralInfo === null || referralInfo === void 0 ? void 0 : referralInfo.invitedUsers) || [])
                                        : ((referralCodeUsersData === null || referralCodeUsersData === void 0 ? void 0 : referralCodeUsersData.users) || []), rowKey: "id", pagination: selectedReferralCode && referralCodeUsersData ? {
                                        current: referralCodeUsersData.page,
                                        pageSize: referralCodeUsersData.limit,
                                        total: referralCodeUsersData.total,
                                        onChange: function (page, pageSize) {
                                            if (selectedReferralCode) {
                                                getUsersByReferralCode({
                                                    referralCode: selectedReferralCode,
                                                    page: page,
                                                    limit: pageSize
                                                });
                                            }
                                        },
                                        showSizeChanger: true,
                                        showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E ".concat(total, " \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439"); }
                                    } : {
                                        pageSize: 10,
                                        showSizeChanger: false,
                                        showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E ".concat(total, " \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439"); }
                                    }, locale: {
                                        emptyText: selectedUser ? (_jsx(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0435\u0449\u0435 \u043D\u0438\u043A\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u043B" })) : (_jsx(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u041F\u043E \u044D\u0442\u043E\u043C\u0443 \u0440\u0435\u0444\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043A\u043E\u0434\u0443 \u0435\u0449\u0435 \u043D\u0435\u0442 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u043D\u044B\u0445" }))
                                    } })) }))] }))] }))] })));
};
export default ReffsControlPage;
